import React from "react";
import { Col, Container, Row, Image, Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import IMAGES from "../images/images";
import {
  StackedCarousel,
  ResponsiveContainer,
} from "react-stacked-center-carousel";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";

export const data = [
  {
    cover: IMAGES.AppImg1,
    title: "Interstaller",
  },
  {
    cover: IMAGES.AppImg2,
    title: "Inception",
  },
  {
    cover: IMAGES.AppImg3,
    title: "Blade Runner 2049",
  },
  {
    cover: IMAGES.AppImg5,
    title: "Icon man 3",
  },
  {
    cover: IMAGES.AppImg4,
    title: "Venom",
  },
];

export const SliderCard = React.memo(function (props) {
  const { data, dataIndex } = props;
  const { cover } = data[dataIndex];
  return (
    <div
      style={{
        backgroundImage: "url(" + IMAGES.PhonePlaceholder + ")",
      }}
      className="placeholderCss"
    >
      <img
        style={{
          objectFit: "cover",
        }}
        alt=""
        draggable={false}
        src={cover}
      />
    </div>
  );
});

const PrivacyScreen = () => {
  const ref = React.useRef();
  return (
    <React.Fragment>
      <section className="bannersectio py-5">
        <Container fluid>
          <Row>
            <Col md={12} lg={12} xl={12}>
              <div className="bannersection__content">
                <p className="text-center">Terms and Conditions</p>
                <p style={{ fontSize: "16px" }}>
                  1. Welcome to Chummy, where we're dedicated to enriching lives
                  by connecting like-minded individuals in a secure, digital
                  environment. Our service allows you to discover groups that
                  match your interests and personality, fostering genuine,
                  platonic friendships. By accessing or using the Chummy app,
                  you agree to comply with these Terms of Service ("ToS"),
                  intertwined with our Privacy Policy. Your agreement forms a
                  binding contract between you and Chummy, so please read
                  carefully. <br />
                  <br />
                  2. User Eligibility Chummy is designed for individuals 18
                  years and older who seek friendship and shared experiences. By
                  registering, you assert that you meet this age criterion,
                  ensuring a mature and respectful user base. <br />
                  <br />
                  3. User Conduct In joining the Chummy community, you commit to
                  commit to uphold the highest standards of respect, integrity,
                  and positive interaction. This commitment extends to all
                  aspects of your participation within the app, including your
                  communications, content sharing, and any real-world
                  interactions facilitated through Chummy. Specifically, you
                  agree to: Respectful Communication: Engage in conversations
                  with kindness, respect, and consideration for others.
                  Offensive, harmful, or disrespectful language is strictly
                  prohibited. This includes but is not limited to threats,
                  harassment, and bullying. Appropriate Content: Ensure that all
                  content you post, including text, images, and links, is
                  appropriate and respectful. Content that is defamatory,
                  obscene, pornographic, violent, or otherwise offensive or
                  illegal is strictly forbidden. Privacy Respect: Honor the
                  privacy and personal information of others. Do not share or
                  disclose any personal information of other users without their
                  explicit consent. This includes private conversations, contact
                  details, and personal data. Non-Discrimination: The Chummy
                  community is diverse and inclusive. Discrimination or hate
                  speech based on race, ethnicity, gender, sexual orientation,
                  age, religion, disability, or any other protected status will
                  not be tolerated. Legal Compliance: Adhere to all applicable
                  laws and regulations while using the app. Illegal activities,
                  including promoting or engaging in illegal acts, are
                  prohibited. No Commercial Use: The app is designed for
                  personal, non-commercial use only. Any use of the app for
                  commercial purposes, including advertising, solicitation, or
                  commercial messaging, is not allowed without prior written
                  permission from Chummy. Violations of these conduct guidelines
                  may result in a range of actions, including but not limited to
                  content removal, temporary account suspension, or permanent
                  account termination. Chummy reserves the right to enforce
                  these policies at our discretion and to report illegal
                  activities to the authorities as necessary. Failure to adhere
                  to these standards can result in immediate account
                  termination. <br /> <br />
                  4. Content Ownership and Rights Policy By posting on Chummy,
                  you retain ownership of your content but grant us a worldwide,
                  perpetual license to use, modify, and display such content
                  within our app. This license is solely for the purpose of
                  operating, promoting, and improving our services. <br />
                  <br />
                  5. Dispute Resolution and Reporting Chummy empowers users to
                  report inappropriate behavior or content through our in-app
                  reporting tool, ensuring a safe environment. While we commit
                  to reviewing all reports, our liability for user interactions
                  is limited. We strive to foster a community of respect and
                  understanding but cannot monitor every conversation. <br />
                  <br />
                  6. Limitation of Liability Limitation of Liability (Enhanced)
                  The Chummy Entities take no responsibility and assume no
                  liability for any user conduct, online or offline, nor do we
                  act as an intermediary or arbitrator in disputes between
                  users. Our platform serves as a facilitation tool for making
                  connections based on shared interests and personality
                  compatibility; however, all interactions, communications, and
                  meetups that occur as a result of using our service are the
                  sole responsibility of the users involved. Specifically:
                  Absence of Liability for User Interactions: Chummy and its
                  entities are not liable for the actions or behaviors of any
                  users, whether online within the app or offline during
                  personal meetups organized through our platform. This
                  includes, but is not limited to, personal disputes, physical
                  or psychological harm, financial loss, or any other damages
                  resulting from interactions or relationships formed on Chummy.
                  No Guarantee of Accuracy: While we strive to provide a
                  platform that matches users based on compatibility, we do not
                  guarantee the accuracy of user profiles, the effectiveness of
                  our matching algorithm, or the sincerity of user intentions.
                  Chummy Is not liable for any deception, misrepresentation, or
                  disappointment that may arise from the use of our services.
                  Exclusion of Liability for External Events: Any real-world
                  activities, meetings, or events that users may organize after
                  connecting through Chummy are beyond our control and
                  oversight. As such, Chummy cannot be held liable for any
                  incidents, injuries, damages, or losses that occur as a result
                  of such external events. Users partake in these activities at
                  their own risk and are encouraged to take all necessary
                  precautions to ensure their safety and well-being. Limitation
                  on Legal Action: Users expressly waive any right to pursue
                  legal action against Chummy and its entities for any
                  incidents, damages, or injuries that arise from user
                  interactions or meetups facilitated by the app. This waiver
                  applies to the fullest extent permitted by law and includes
                  any claims of negligence against Chummy. Indemnification:
                  Users agree to indemnify, defend, and hold harmless Chummy and
                  its entities from any claims, liabilities, damages, losses,
                  and expenses, including reasonable attorneys’ fees, arising
                  from or in any way connected with their access to or use of
                  the app, their violation of these Terms of Service, their
                  interaction with other users, or their participation in any
                  activities, meetings, or events organized through or as a
                  result of using Chummy. Chummy’s total liability for any
                  claims under these terms, including for any implied
                  warranties, is limited to the amount you paid us to use the
                  app or, if we choose, to supplying you the services again.
                  This does not affect any liability that cannot be excluded or
                  limited under applicable law but is intended to operate to the
                  fullest extent permitted by law. By using Chummy, you
                  acknowledge that you have read, understood, and agreed to
                  these terms, recognizing that Chummy provides a platform for
                  connection but does not oversee personal interactions and is
                  thereby not liable for the outcomes of such interactions.{" "}
                  <br />
                  <br />
                  7. Privacy Policy Your privacy is of utmost importance. Our
                  Privacy Policy, which is part of these ToS, outlines how we
                  handle your personal and sensitive information. Your use of
                  Chummy signifies your consent to this policy. <br />
                  <br />
                  8. Amendments to ToS We reserve the right to update these ToS
                  at any time. Such changes will be effective immediately upon
                  posting. Continued use of the app after changes means you
                  accept those changes. <br />
                  <br />
                  9. Governing Law These ToS are governed by the laws of Guam,
                  ToS are governed by the laws of Guam, USA, without regard to
                  its conflict of laws principles. Disputes arising will be
                  resolved exclusively in the courts of Guam, USA. <br />
                  <br />
                  10. Contact Us If you have questions about these ToS or need
                  to report a violation, please reach out to us at
                  rocco@chummy.app
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default PrivacyScreen;
